import { types } from "../../actions"
import collection from "../collection"

const getInitialState = () => ({
  /* Engine & model observed by saga */
  observer: null,
  queries: {},
})

export default function collectionsReducer(state = getInitialState(), action) {
  const { query, model } = action

  switch (action.type) {
    case types.setObserver:
      return {
        ...state,
        observer: action.observer,
      }
    case types.unsetObserver:
      return {
        ...state,
        observer: null,
      }
    default: {
      /* If cumulative mode is active, then query shouldn't be an identifier
       * of the collection */
      const ignoreQuery =
        model.collection &&
        (model.collection.cumulative || model.collection.ignoreQueryName)

      const advancedName =
        model.collection && model.collection.name ? model.collection.name : `{}`

      const key = ignoreQuery
        ? `${advancedName}{}`
        : `${advancedName}${JSON.stringify(query)}`

      // TODO temporary turn off, because can't track when an extra release
      // TODO happens, so required collection being removed from store
      /* if (action.type === types.release) {
        const currentCollection = state.queries[key]

        if (currentCollection && currentCollection.involved <= 1) {
          return {
            ...state,
            queries: omit(state.queries, [key]),
          }
        }
      } */

      const currentQueryState = state.queries[key]
      const nextQueryState = collection(currentQueryState, action)

      if (nextQueryState !== currentQueryState) {
        return {
          ...state,
          queries: {
            ...state.queries,
            [key]: nextQueryState,
          },
        }
      }

      return state
    }
  }
}
